import { useDeviceType } from '@cian/ui-kit';
import React, { PropsWithChildren } from 'react';
import cn from 'classnames';

import * as styles from './styles.css';

export const BenefitsCardList: React.FC<PropsWithChildren> = ({ children }) => {
  const deviceType = useDeviceType();

  return <ul className={cn(styles['list'], styles[deviceType])}>{children}</ul>;
};
